import { render } from "./VesselsPage.vue?vue&type=template&id=1549f2f0&scoped=true"
import script from "./VesselsPage.vue?vue&type=script&lang=js"
export * from "./VesselsPage.vue?vue&type=script&lang=js"

import "./VesselsPage.vue?vue&type=style&index=0&id=1549f2f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1549f2f0"]])

export default __exports__